export const dashboardTranslations = {
  en: {
    title: 'Dashboard',
    description: 'Overview of your business performance',
    weekdays: ['M', 'T', 'W', 'T', 'F', 'S', 'S'],
    interactionChart: {
      title: 'Client Interactions',
      today: 'Today',
      thisWeek: 'This Week'
    },
    revenueByUser: {
      title: 'Revenue by User',
      noData: 'No revenue data available',
      periods: 'months',
      yearToDate: 'Year to date'
    },
    activities: {
      title: 'My Activities',
      addNew: 'Add New',
      noActivities: 'No activities scheduled',
      addActivity: 'Add Activity',
      groups: {
        overdue: 'Overdue',
        today: 'Today',
        tomorrow: 'Tomorrow',
        thisWeek: 'This Week',
        upcoming: 'Upcoming',
        laterMonth: 'Within a month',
        later3Months: 'Next 3 months',
        laterYear: 'This year',
        laterLongTerm: 'Future'
      },
      timeFormat: 'h:mm a',
      complete: 'Mark as complete'
    },
    stats: {
      totalRevenue: 'Total Revenue',
      avgDealValue: 'Average Deal Value',
      conversion: 'Conversion Rate',
      totalDeals: 'Total Deals',
      pipeline: 'Pipeline Value',
      monthlyRevenue: 'Monthly Revenue',
      period: {
        thisMonth: 'This Month',
        lastMonth: 'Last Month',
        thisQuarter: 'This Quarter',
        thisYear: 'This Year',
        custom: 'Custom'
      }
    },
    salesTarget: {
      title: 'Sales Target',
      progress: 'Progress',
      remaining: 'Remaining',
      target: 'Target',
      achieved: 'Achieved',
      overTarget: 'Over Target',
      timeRemaining: 'Time Remaining',
      daysLeft: 'days left'
    },
    leaderboard: {
      title: 'Top Performers',
      noData: 'No data available',
      salesVolume: 'Sales Volume',
      deals: 'Deals',
      revenue: 'Revenue',
      othersTitle: 'Other Performers'
    },
    funnel: {
      title: 'Sales Funnel',
      draft: 'Draft',
      sent: 'Sent',
      accepted: 'Accepted',
      rejected: 'Rejected',
      conversionRate: 'Conversion Rate'
    },
    teamTrends: {
      title: 'Team Performance',
      noData: 'No data available',
      thisMonth: 'This Month',
      lastMonth: 'Last Month',
      thisQuarter: 'This Quarter',
      thisYear: 'This Year'
    },
    errors: {
      accessLimited: 'Limited Access',
      notAssociated: 'Your profile is not associated with an organization or there are network issues. Contact an administrator to resolve the problem.'
    },
    leadsStats: {
      title: 'Lead Creation Analysis',
      subtitle: 'Team performance over time',
      totalLeads: 'Total Leads',
      dailyAverage: 'Daily Average',
      vsPreviousPeriod: 'vs Previous Period',
      topPerformer: 'Top Performer',
      leads: 'leads',
      dailyDetails: 'Daily Details',
      noData: 'No leads found in the selected period',
      date: 'Date',
      total: 'Total',
      byUser: 'By User',
      movingAverage: '7-day Avg',
      performance: 'Performance',
      export: 'Export',
      excelFormat: 'Excel (.xlsx)',
      csvFormat: 'CSV (.csv)',
      dateRange: {
        from: 'From',
        to: 'To',
        apply: 'Apply'
      }
    },
    teamActivity: {
      title: 'Team Lead Activity',
      subtitle: 'Actions on leads by team member in the period',
      leadsCreated: 'Leads created',
      stateChanges: 'State changes',
      notesAdded: 'Notes added',
      tasksCreated: 'Tasks created',
      tasksCompleted: 'Tasks completed',
      dealsCreated: 'Quotes created',
      contactsCreated: 'Contacts created',
      totalActions: 'Total actions',
      dailyBreakdown: 'Daily breakdown',
      day: 'Day',
      noData: 'No activity found in the selected period'
    },
    pipelineAnalytics: {
      title: 'Pipeline Analysis',
      subtitle: 'Performance and conversions by state',
      totalLeads: 'Total Leads',
      converted: 'Converted',
      conversionRate: 'Conversion Rate',
      avgTime: 'Avg Time',
      stateDetails: 'State Details',
      userPerformance: 'User Performance',
      leads: 'Leads',
      avgTimeInState: 'Avg Time',
      conversionToNext: 'Conv. →',
      user: 'User',
      standard: 'Standard'
    }
  },
  it: {
    title: 'Dashboard',
    description: 'Panoramica delle prestazioni aziendali',
    weekdays: ['L', 'M', 'M', 'G', 'V', 'S', 'D'],
    interactionChart: {
      title: 'Interazioni clienti',
      today: 'Oggi',
      thisWeek: 'Questa settimana'
    },
    revenueByUser: {
      title: 'Ricavi per utente',
      noData: 'Nessun dato di ricavo disponibile',
      periods: 'mesi',
      yearToDate: 'Anno in corso'
    },
    activities: {
      title: 'Le mie attività',
      addNew: 'Aggiungi',
      noActivities: 'Nessuna attività programmata',
      addActivity: 'Aggiungi attività',
      groups: {
        overdue: 'In ritardo',
        today: 'Oggi',
        tomorrow: 'Domani',
        thisWeek: 'Questa settimana',
        upcoming: 'Prossimamente',
        laterMonth: 'Entro un mese',
        later3Months: 'Prossimi 3 mesi',
        laterYear: "Quest'anno",
        laterLongTerm: 'Futuro'
      },
      timeFormat: 'HH:mm',
      complete: 'Segna come completata'
    },
    stats: {
      totalRevenue: 'Ricavi totali',
      avgDealValue: 'Valore medio offerte',
      conversion: 'Tasso di conversione',
      totalDeals: 'Offerte totali',
      pipeline: 'Valore pipeline',
      monthlyRevenue: 'Ricavi periodo',
      period: {
        thisMonth: 'Questo Mese',
        lastMonth: 'Mese Scorso',
        thisQuarter: 'Questo Trimestre',
        thisYear: 'Quest\'Anno',
        custom: 'Personalizzato'
      }
    },
    salesTarget: {
      title: 'Obiettivo di vendita',
      progress: 'Progresso',
      remaining: 'Rimanente',
      target: 'Obiettivo',
      achieved: 'Raggiunto',
      overTarget: 'Superato',
      timeRemaining: 'Tempo Rimanente',
      daysLeft: 'giorni rimasti'
    },
    leaderboard: {
      title: 'Migliori performer',
      noData: 'Nessun dato disponibile',
      salesVolume: 'Volume Vendite',
      deals: 'Offerte',
      revenue: 'Ricavi',
      othersTitle: 'Altri Performer'
    },
    funnel: {
      title: 'Funnel di vendita',
      draft: 'Bozze',
      sent: 'Inviate',
      accepted: 'Accettate',
      rejected: 'Rifiutate',
      conversionRate: 'Tasso di Conversione'
    },
    teamTrends: {
      title: 'Performance del Team',
      noData: 'Nessun dato disponibile',
      thisMonth: 'Questo Mese',
      lastMonth: 'Mese Scorso',
      thisQuarter: 'Questo Trimestre',
      thisYear: 'Quest\'Anno'
    },
    errors: {
      accessLimited: 'Accesso Limitato',
      notAssociated: 'Il tuo profilo non è associato a un\'organizzazione o ci sono problemi di rete. Contatta un amministratore per risolvere il problema.'
    },
    leadsStats: {
      title: 'Analisi creazione lead',
      subtitle: 'Performance del team nel tempo',
      totalLeads: 'Lead Totali',
      dailyAverage: 'Media/Giorno',
      vsPreviousPeriod: 'vs Periodo Prec.',
      topPerformer: 'Top Performer',
      leads: 'lead',
      dailyDetails: 'Dettaglio Giornaliero',
      noData: 'Nessun lead trovato nel periodo selezionato',
      date: 'Data',
      total: 'Totale',
      byUser: 'Per Utente',
      movingAverage: 'Media 7gg',
      performance: 'Performance',
      export: 'Export',
      excelFormat: 'Excel (.xlsx)',
      csvFormat: 'CSV (.csv)',
      dateRange: {
        from: 'Da',
        to: 'A',
        apply: 'Applica'
      }
    },
    teamActivity: {
      title: 'Movimentazione lead del team',
      subtitle: 'Azioni sui lead per persona nel periodo',
      leadsCreated: 'Lead creati',
      stateChanges: 'Spostamenti di stato',
      notesAdded: 'Note aggiunte',
      tasksCreated: 'Task commerciali create',
      tasksCompleted: 'Task commerciali completate',
      dealsCreated: 'Offerte create',
      contactsCreated: 'Contatti creati',
      totalActions: 'Azioni totali',
      dailyBreakdown: 'Dettaglio giornaliero',
      day: 'Giorno',
      noData: 'Nessuna azione trovata nel periodo selezionato'
    },
    pipelineAnalytics: {
      title: 'Analisi Pipeline',
      subtitle: 'Performance e conversioni per stato',
      totalLeads: 'Lead Totali',
      converted: 'Convertiti',
      conversionRate: 'Tasso Conversione',
      avgTime: 'Tempo Medio',
      stateDetails: 'Dettaglio per Stato',
      userPerformance: 'Performance per Utente',
      leads: 'Lead',
      avgTimeInState: 'Tempo Medio',
      conversionToNext: 'Conv. →',
      user: 'Utente',
      standard: 'Standard'
    }
  }
};